// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum UnpairedPaymentStatus {
  New = "NEW",
  RefundCreated = "REFUND_CREATED",
}
export default UnpairedPaymentStatus;
